/*------------------------------------------------------------------
Web Vitals
------------------------------------------------------------------*/

// import { getLCP, getFID, getCLS } from 'web-vitals';

// getCLS(console.log);
// getFID(console.log);
// getLCP(console.log);

/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import './../styles/style.scss';

import { $, $$ } from './lib';

import './animations';

import { VideoBlock } from './video-block';

/*------------------------------------------------------------------
Import external
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {


    // Add an event listener to avoid sending people to the generic contact page when they are on a centre page
    // And instead scroll them down to that centres contact form
    if (document.body.classList.contains('Toast\\Pages\\CentrePage')) {
        let title = $('[data-title="Contact Us"]');
        if (title) {
            title.addEventListener('click', (e) => {
                e.preventDefault();
                const yOffset = -80;
                const y = $('.js-enquire').getBoundingClientRect().top + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            });
        }
    }


    /*------------------------------------------------------------------
    Scroll a hash into view on page load
    ------------------------------------------------------------------*/
    if (window.location.hash) {
        let hash = window.location.hash;
        if ($(hash)) {
            $(hash).scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    /*------------------------------------------------------------------
    Post Load classname removal
    ------------------------------------------------------------------*/
    setTimeout(() => {
        $$('.js-postload').forEach(element => {
            element.classList.remove('js-postload');
        });
    }, 1000);



    /*------------------------------------------------------------------
    Sticky header  
    ------------------------------------------------------------------*/

    let previousScrollPosition = 0;
    let scrollDelta = 5;
    let header = $('.header');
    let headerHeight = (header) ? header.clientHeight / 3 : 0;

    const stickyHeader = () => {
        let st = window.scrollY;
        if (Math.abs(previousScrollPosition - st) <= scrollDelta) return;
        if (st === 0) {
            header.classList.remove('nav-down');
            header.classList.remove('nav-up');
        } else if (st > previousScrollPosition && st > headerHeight) {
            header.classList.remove('nav-down');
            header.classList.add('nav-up');
        } else {
            if (st + window.innerHeight < document.body.clientHeight) {
                header.classList.add('nav-down');
                header.classList.remove('nav-up');
            }
        }
        previousScrollPosition = st;
    }

    window.addEventListener('scroll', stickyHeader);


    /*------------------------------------------------------------------
    Blocks
    ------------------------------------------------------------------*/
    const videoBlocks = document.querySelectorAll('.video-block');

    videoBlocks.forEach((block) => {
        const videoBlock = new VideoBlock(block);
    });


});

